<section *ngIf="!displayShortNavigation">
  <div class="menuItem sidebar" (click)="redirectTo('tabProperty')"
       [ngClass]="{'active': selectedTab === activeTab.Properties}">
    <div class="sidebar-icon-container">
      <svg-icon src='./assets/icons/Properties_icon.svg' class="menu-navigation-icon"
                title="{{'comparables.properties' | translate | uppercase}}" align='center'></svg-icon>
    </div>
    <div class="menu-navigation-title">{{'comparables.properties' | translate | uppercase}}</div>
  </div>
  <div class="menuItem sidebar" (click)="redirectTo('tabValuation')"
       [ngClass]="{'active': selectedTab === activeTab.Valuations}">
    <div class="sidebar-icon-container">
      <svg-icon src='./assets/icons/Valuations_icon.svg' class="menu-navigation-icon"
                title="{{'comparables.valuations' | translate | uppercase}}" align='center'></svg-icon>
    </div>
    <div class="menu-navigation-title">{{'comparables.valuations' | translate | uppercase}}</div>
  </div>
  <div class="menuItem sidebar" (click)="redirectTo('tabLeases')"
       [ngClass]="{'active': selectedTab === activeTab.Leases}">
    <div class="sidebar-icon-container">
      <svg-icon src='./assets/icons/Tenant_icon.svg' class="menu-navigation-icon"
                title="{{'comparables.leases' | translate | uppercase}}" align='center'></svg-icon>
    </div>
    <div class="menu-navigation-title">{{'comparables.leases' | translate | uppercase}}</div>
  </div>
</section>
